<template>
	<div class="user_wrap">
		<div class="top_header">
			<router-link to="/safe" class="set_go"></router-link>
			<!-- <router-link to="/kefu" class="kf_go"></router-link> -->
			<div class="user_detail" @click="openEditProfile">
				<div class="user_header">
					<img :src="data.headimg ? data.headimg : data.user_icon" alt="">
				</div>
				<div class="user_name">
					<div class="user_all">
						<p class="user_nickname">{{data.name?data.name:data.mobile}}</p>
						<i class="edit_icon"></i>
					</div>
					<div class="sm flex_center" v-if="data.is_auth == '0'" @click.stop="$router.push('/auth')"><span>未实名认证</span><i class="triangle"></i></div>
					<div class="sm flex_center" v-if="data.is_auth == '1'"><span>已实名认证</span></div>
				</div>
			</div>
			<div class="user_active">
				<div class="left_tit">
					<i></i>
					<span>通知</span>
				</div>
				<div class="center_msg">
					<p class="van-ellipsis">{{firstMsg}}</p>
				</div>
				<router-link to="/notice" class="look_active flex_center"><span>立即查看</span><i class="triangle"></i></router-link>
			</div>
		</div>
		<div class="part1">
			<div class="tit">
				<h5>我的服务</h5>
			</div>
			<div class="wrap">
				<router-link to="/funds" class="item">
					<img class="icon" src="../images/user/icon5.png" alt="" />
					<p class="info">我的余额</p>
				</router-link>
				<router-link to="/about" class="item">
					<img class="icon" src="../images/user/icon2.png" alt="" />
					<p class="info">业务须知</p>
				</router-link>
				<router-link to="/safe" class="item">
					<img class="icon" src="../images/user/my.png" alt="" />
					<p class="info">账号设置</p>
				</router-link>
				<!-- 在线客服入口暂时隐藏
				<router-link to="/kefu" class="item">
					<img class="icon" src="../images/user/kefu.png" alt="" />
					<p class="info">在线客服</p>
				</router-link>
				-->
			</div>
		</div>
		<div class="part2 mall_service">
			<div class="tit">
				<h5>商城服务</h5>
			</div>
			<div class="wrap">
				<router-link to="/shopOrders" class="item">
					<img class="icon" src="../images/user/icon4.png" alt="" />
					<p class="info">商城订单</p>
				</router-link>
				<router-link to="/kamiInfo" class="item">
					<img class="icon" src="../images/user/icon1.png" alt="" />
					<p class="info">卡密信息</p>
				</router-link>
				<router-link to="/logistics" class="item">
					<img class="icon" src="../images/user/icon3.png" alt="" />
					<p class="info">物流中心</p>
				</router-link>
			</div>
		</div>

	<!-- 编辑资料弹窗 -->
	<div class="edit_mask" v-if="editShow" @click.self="closeEditProfile">
		<div class="edit_pop">
			<div class="edit_pop__title">编辑资料</div>
			<div class="edit_pop__avatar" @click="$refs.avatarInput && $refs.avatarInput.click()">
				<img :src="editAvatar || data.headimg || data.user_icon" alt="">
				<span class="edit_pop__avatar-tip">点击更换头像</span>
			</div>
			<input ref="avatarInput" type="file" accept="image/*" style="display:none" @change="onAvatarChange" />
			<div class="edit_pop__field">
				<span class="edit_pop__label">昵称</span>
				<input class="edit_pop__input" v-model="editName" maxlength="20" placeholder="请输入昵称" />
			</div>
			<div class="edit_pop__btns">
				<button class="edit_pop__btn edit_pop__btn--cancel" type="button" @click="closeEditProfile">取消</button>
				<button class="edit_pop__btn edit_pop__btn--save" type="button" @click="saveProfile">保存</button>
			</div>
		</div>
	</div>
</div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch'
	import {
		Swipe,
		SwipeItem,
		NoticeBar
	} from "vant";

	Vue.use(NoticeBar);

	export default {
		name: "user",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
		},
		data() {
			return {
				data: {},
                load: false,
                firstMsg:"消息列表",
                editShow: false,
                editName: "",
                editAvatar: ""
			};
		},
		created() {
			this.$parent.footer('user');
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/info').then((r) => {
					this.data = r.data;
                    this.load = true;
				});
                
                // 消息
                Fetch('/user/notice').then((r) => {
                    
                    var msg_arr = []
                    r.data.list.forEach(item=>{
                        if(!item.is_read){
                            msg_arr.push(item);
                        }
                    })
                    
                    if(msg_arr.length!=0){
                        this.firstMsg = msg_arr[0].title
                    }
                }); 
			},
            openEditProfile() {
                this.editName = this.data.name || "";
                this.editAvatar = "";
                this.editShow = true;
            },
            closeEditProfile() {
                this.editShow = false;
                this.editAvatar = "";
            },
            onAvatarChange(event) {
                var files = event.target.files || [];
                if (!files.length) return;
                var file = files[0];
                if (file.size > 4 * 1024 * 1024) {
                    this.$toast("图片不能超过4M");
                    event.target.value = "";
                    return;
                }
                var reader = new FileReader();
                reader.onload = (e) => {
                    this.editAvatar = e.target.result || "";
                };
                reader.readAsDataURL(file);
                event.target.value = "";
            },
            saveProfile() {
                var name = (this.editName || "").trim();
                if (!name) {
                    this.$toast("请输入昵称");
                    return;
                }
                var params = { name: name };
                if (this.editAvatar) {
                    params.headimg = this.editAvatar;
                }
                Fetch('/user/update_user_info', params).then(() => {
                    this.$toast({ background: "#07c160", message: "修改成功" });
                    this.editShow = false;
                    this.editAvatar = "";
                    Fetch('/user/info').then((r) => {
                        this.data = r.data;
                    });
                });
            },
		}
	};
</script>

<style lang="less" scoped>
	a{
		color: #222;
	}
	.user_wrap {
		width: 100%;
		min-height: 100vh;
		background: linear-gradient(180deg, #fff4f5 0, #fafafa 138px, #fafafa 100%);
		max-width: 500px;
		margin: 0 auto;
		overflow: hidden;
		padding-bottom: 18px;
		box-sizing: border-box;
	}

	.top_header {
		position: relative;
		width: 100%;
		height: 198px;
		background: url(../images/user/header.png) no-repeat center center;
		background-size: 100% 100%;
		box-shadow: 0 12px 28px rgba(227, 56, 46, 0.12);

		.set_go,
		.kf_go {
			width: 30px;
			height: 30px;
			position: absolute;
			top: 14px;
			border-radius: 50%;
			background-color: rgba(255, 255, 255, 0.2);
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
		}

		.set_go {
			right: 16px;
			background: url(../images/user/set_icon.png) no-repeat center center;
			background-size: 18px 18px;
			background-color: rgba(255, 255, 255, 0.18);
		}

		.kf_go {
			right: 16px;
			background: url(../images/user/kf_icon.png) no-repeat center center;
			background-size: 18px 18px;
			background-color: rgba(255, 255, 255, 0.18);
		}
	}

	.user_detail {
		width: 100%;
		padding: 0 18px;
		position: absolute;
		top: 42px;
		display: flex;
		justify-content: flex-start;
		align-items: center;

		.user_header {
			width: 68px;
			height: 68px;
			overflow: hidden;
			border-radius: 50%;
			border: 4px solid rgba(255, 255, 255, 0.28);
			box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);

			img {
				display: block;
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.user_name {
			margin-left: 10px;
			flex: 1;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			color: #FFFFFF;

			.user_all {
				display: flex;
				justify-content: flex-start;
				align-items: center;

				.user_nickname {
					line-height: 24px;
					font-size: 18px;
					font-weight: 600;
					text-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
				}
			}

			.sm {
				display: inline-flex;
				width: auto;
				min-width: 92px;
				height: 24px;
				background: rgba(237, 15, 64, 0.92);
				border-radius: 12px;
				border: 1px solid rgba(255, 255, 255, 0.18);
				padding: 0 10px;
				margin-top: 9px;
				white-space: nowrap;
				box-shadow: 0 6px 16px rgba(187, 12, 12, 0.18);

				span {
					font-size: 12px;
					transform: none;
				}
			}
		}
	}

	.flex_center {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.triangle {
		width: 0;
		height: 0;
		border: 3px solid transparent;
		border-left-color: #FFFFFF;
	}

	.edit_icon {
		width: 16px;
		height: 16px;
		display: inline-block;
		margin-left: 6px;
		background: url(../images/user/edit.png) no-repeat center center;
		background-size: 100% 100%;
		vertical-align: middle;
	}

	.user_active {
		width: calc(100% - 24px);
		height: 72px;
		background: url(../images/user/msg.png) no-repeat center center;
		background-size: 100% 100%;
		position: absolute;
		bottom: 10px;
		left: 12px;
		padding: 0 16px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		border-radius: 18px;
		box-shadow: 0 12px 24px rgba(28, 39, 79, 0.16);

		.left_tit {
			width: 78px;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;

			i {
				width: 22px;
				height: 23px;
				background: url(../images/user/icon11.png) no-repeat center center;
				background-size: 100% 100%;
			}

			span {
				line-height: 17px;
				font-size: 12px;
				color: #E3E07A;
			}
		}

		.center_msg {
			flex: 1;
            margin-right: 10px;
			display: flex;
			justify-content: flex-start;
			flex-direction: column;
			align-items: flex-start;
			padding-left: 12px;
			border-left: 1px solid #EEE47973;
			white-space: nowrap;
            overflow: hidden;

			p:first-child {
                width: 100%;
				height: 18px;
				line-height: 18px;
				font-size: 13px;
				color: #E3E07A;
			}
		}

		.look_active {
			width: 76px;
			height: 26px;
			background: #FFDF6E;
			border-radius: 13px;
			font-weight: 400;
			color: rgba(28, 39, 79, 1);
			line-height: 26px;
			margin-right: 2px;
			white-space: nowrap;
			box-shadow: 0 6px 16px rgba(255, 223, 110, 0.28);

			span {
				font-size: 12px;
				line-height: 26px;
				transform: none;
			}

			.triangle {
				border-left-color: #1C274F;
				margin-left: 3px;
			}
		}
	}

	.part1 {
		width: calc(100% - 24px);
		background: rgba(255, 255, 255, 1);
		box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
		border-radius: 18px;
		margin: 16px auto 0 auto;
		overflow: hidden;

		.tit {
			width: 100%;
			border-bottom: 1px solid #F5F5F5;
			padding: 0 14px;
			height: 42px;
			line-height: 42px;

			h5 {
				font-size: 15px;
				font-weight: 600;
				color: rgba(0, 0, 0, 0.84);
			}
		}

		.wrap {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 18px 8px 20px 8px;

			.item {
				width: 25%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				transition: transform 0.2s ease;

				&:active {
					transform: scale(0.96);
				}

				.icon {
					width: 42px;
					height: 42px;
				}

				.info {
					width: 100%;
					min-height: 17px;
					line-height: 17px;
					font-size: 12px;
					color: rgba(0, 0, 0, 0.72);
					text-align: center;
					margin-top: 8px;
					padding: 0 4px;
				}
			}
		}
	}

	.part2.mall_service .wrap{
		padding: 16px 8px 18px 8px;
		justify-content: space-between;
		.item{
			padding: 6px 0;
		}
	}
	
	.part2 {
		width: calc(100% - 24px);
		background: rgba(255, 255, 255, 1);
		box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
		border-radius: 18px;
		margin: 12px auto 0 auto;
		color: #000000;

		.tit {
			width: 100%;
			border-bottom: 1px solid #F5F5F5;
			padding: 0 14px;
			height: 42px;
			line-height: 42px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			h5 {
				font-size: 15px;
				font-weight: 600;
				color: rgba(0, 0, 0, 0.84);
			}

			p {
				color: rgba(0,0,0,.6);
				display: flex;
				align-items: center;

				span {
					font-size: 12px;
					transform: scale(0.85);
				}

				i {
					width: 4px;
					height: 7px;
					background: url(../images/user/right.png) no-repeat center center;
					background-size: 100% 100%;
					margin-left: 7px;
				}
			}
			.sm_go{
				color: #3D96FF;
				i{
					background: url(../images/user/right2.png) no-repeat center center;
					background-size: 100% 100%;
				}
			}
		}

		.wrap {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 18px 8px 20px 8px;

			.money_all {
				width: 94px;
				border-right: 1px solid #EAEAEA;
				height: 43px;
				flex-direction: column;
			}

			.money,
			.item {
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				width: 25%;
				padding: 0;
				transition: transform 0.2s ease;

				&:active {
					transform: scale(0.96);
				}
			}

			.money_num {
				font-size: 16px;
				height: 34px;
				line-height: 16px;
				font-weight: bold;
				width: 200%;
				white-space: nowrap;

				span {
					font-size: 12px;
					line-height: 12px;
					margin-top: 4px;
				}
			}

			.icon {
				width: 40px;
				height: 40px;

			}

			.info {
				font-size: 12px;
				line-height: 17px;
				white-space: nowrap;
				color: rgba(0, 0, 0, 0.72);
				margin-top: 8px;
			}
		}
	}

	/* ---- 编辑资料弹窗 ---- */
	.edit_mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		background: rgba(15, 23, 42, 0.45);
		display: flex;
		justify-content: center;
		align-items: flex-end;
	}

	.edit_pop {
		width: 100%;
		max-width: 500px;
		margin: 0 auto;
		background: #fff;
		border-radius: 20px 20px 0 0;
		padding: 24px 20px 28px;
		box-sizing: border-box;
		box-shadow: 0 -8px 32px rgba(15, 23, 42, 0.12);
		animation: editPopUp 0.25s ease;
	}

	@keyframes editPopUp {
		from {
			transform: translateY(60px);
			opacity: 0.6;
		}
		to {
			transform: translateY(0);
			opacity: 1;
		}
	}

	.edit_pop__title {
		text-align: center;
		font-size: 17px;
		font-weight: 600;
		color: #1e293b;
		margin-bottom: 20px;
	}

	.edit_pop__avatar {
		width: 84px;
		height: 84px;
		margin: 0 auto 18px;
		border-radius: 50%;
		overflow: hidden;
		position: relative;
		border: 3px solid #ffe3e3;
		cursor: pointer;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
		}

		&-tip {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			padding: 4px 0;
			text-align: center;
			font-size: 11px;
			color: #fff;
			background: rgba(0, 0, 0, 0.45);
		}
	}

	.edit_pop__field {
		display: flex;
		align-items: center;
		height: 48px;
		padding: 0 14px;
		border-radius: 12px;
		background: #f8fafc;
		border: 1px solid #eef2f7;

		.edit_pop__label {
			font-size: 14px;
			color: #334155;
			margin-right: 12px;
			flex-shrink: 0;
		}

		.edit_pop__input {
			flex: 1;
			min-width: 0;
			border: none;
			outline: none;
			background: transparent;
			font-size: 15px;
			color: #1e293b;
		}

		.edit_pop__input::placeholder {
			color: #b6c2d2;
		}
	}

	.edit_pop__btns {
		display: flex;
		gap: 12px;
		margin-top: 22px;

		.edit_pop__btn {
			flex: 1;
			height: 46px;
			border-radius: 999px;
			font-size: 15px;
			font-weight: 600;
			transition: transform 0.2s ease;

			&:active {
				transform: scale(0.97);
			}
		}

		.edit_pop__btn--cancel {
			background: #f1f5f9;
			color: #64748b;
		}

		.edit_pop__btn--save {
			background: linear-gradient(90deg, #e33a2e 0%, #f2564a 100%);
			color: #fff;
			box-shadow: 0 8px 18px rgba(227, 58, 46, 0.24);
		}
	}
</style>
